import { useEffect, useState } from "react";

/** Keep an unfinished number editable until blur or Enter. */
export function PlaybackNumberInput({ id, value, min, max, onCommit }: {
  id: string;
  value: number;
  min: number;
  max: number;
  onCommit: (value: number) => void;
}) {
  const [input, setInput] = useState(String(value));
  useEffect(() => setInput(String(value)), [value]);
  function commit() {
    const parsed = Number(input);
    const next = input.trim() !== "" && Number.isFinite(parsed)
      ? Math.max(min, Math.min(max, Math.round(parsed)))
      : value;
    setInput(String(next));
    if (next !== value) onCommit(next);
  }
  return <input id={id} type="number" min={min} max={max} step={1} inputMode="numeric"
    value={input} onChange={(event) => setInput(event.target.value)} onBlur={commit}
    onKeyDown={(event) => { if (event.key === "Enter") event.currentTarget.blur(); }} />;
}
